import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, DialogContainer, TextField,SelectionControl } from 'react-md';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { browserHistory } from 'react-router';
import { SegmentedControl } from 'segmented-control';
import ApiRequestService from '../component/ApiRequestService';
import restoreQuestionBankHandler from '../component/ArchiveRestoreAPI';
import LoadingSpinner from '../component/LoadingSpinner';
import Properties from '../component/Properties';
import SecureShow from '../component/SecureShow';
import SelectBox from '../component/SelectBox';
import TableRow from '../component/TableRow';
import categoryStyles from '../css/categoryStyles.css.js';
import '../css/mediaCss.css';
import styles from '../css/styles.css.js';
import UserAccessDetails from '../lib/UserAccessDetails';
import ExplanationsList from './ExplanationsList';
import ReactTooltip from 'react-tooltip';
import HelpText from '../lib/help-text';
import { AppSetting, AppProperties,
  ADMIN_USER_ROLE,
  SUBCATEGORY_STATE_MODE,
  QUESTION_STATE_MODE,
  EXPLANATIONS_STATE_MODE,
  TUTORIALS_STATE_MODE
} from '../common/function';
import SearchBar from '../component/SearchBar';
import { CSVLink } from "react-csv";
import { BeatLoader } from 'react-spinners';
import moment from 'moment';
import CustomSegmentedControl from '../lib/components/CustomSegementedControl.js';
import ColumnHeader from '../component/ColumnHeader.js';
import QBDeleteDialog from './dialogs/QBDeleteDialog.jsx';
import QBExplanationHeader from '../component/QBExplanationHeader.js';
import Tutorials from './Tutorials/Tutorials.jsx';
import { QBSyncInUseByLibraryDialog } from './AssignmentMatrixLibrary/LibrarySync';


let category = {
  category_name: '',
  category_label:'',
  category_id: '',
  subject_id:''  
};

export default class Category extends Component {
  userAccessDetails = new UserAccessDetails();
  helpTextModel = new HelpText();
  AppSetting = AppSetting();
  appProperties = AppProperties();
  baseFolder = this.appProperties.baseFolder;

  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      visible: false,
      redirectLoading:false,
      temp_category: category,
      temp_id: '',
      addMode: true,
      categoryDiv: true,
      questionsDiv: false,
      explanationDiv: false,
      countLoading: false,
      subject_id: this.props.location.query.subject_id,
      topic_id: this.props.location.query.topic_id,
      subject_name: this.props.location.query.subject_name,
      topic_name: this.props.location.query.topic_name,
     
      mode: QUESTION_STATE_MODE, // 0 - SubCat, 1 - Questions, 2 - Explanations
      loading: true,
      calculationLoading: false,
      errorMessage: '',
      errorType: '',
      moveCategoryVisible: false,
      selectBoxSubjectDefaultId: parseInt(this.props.location.query.subject_id,10),
      selectBoxTopicDefaultId: parseInt(this.props.location.query.topic_id,10),
      showTopicsSelectBox: true,
      subjects: [],
      instAllSubjects:[],
      topics: [],
      selectcategories: [],
      subjectId:0,
      topicId:0,
      moveCategoryId:0,
      readOnly:this.props.location.query.archive_mode === 'true',
      archive_id:parseInt(this.props.location.query.archive_id,10),
      archive_mode:this.props.location.query.archive_mode,
      instructor_name: window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`),
      userprofilerole : parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10),
      instSubjects:[],
      currSubject:false,
      countOfTCSQ:[],
      explanationCountMap:{}, // key is subjectID_topicID_categoryID
      copyCategoryVisible: false,
      copyCategoryId: 0,
      copyCategoryName:"",
      syncAccess:false,
      AllCatForSuperadmin:false,
      lastComputedAt: null,
      topicExplanationCount: 0,
      topicTutorialsCount: 0,

      showDeleteDialog: false,
      deleteData: null,
      deleteIndex: -1,
      actionLoading: false,
      // The library matrices that refused this category's sync being switched
      // off; null while there is nothing to show.
      blockingLibraryMatrices: null,
      _userAccessDetails: JSON.parse(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_userAccessDetails`)),

    };

    this.deleteCategory = this.deleteCategory.bind(this);
    this.addCategory = this.addCategory.bind(this);
    this.changeCategoryName = this.changeCategoryName.bind(this);
    this.changeCategoryLabel = this.changeCategoryLabel.bind(this);
    this.updateCategory = this.updateCategory.bind(this);
    this.moveCategoryDetails = this.moveCategoryDetails.bind(this);
    this.isEnterPressed = this.isEnterPressed.bind(this);    
    
    this.categoryMoveHide = this.categoryMoveHide.bind(this);
    this.categoryMoveShow = this.categoryMoveShow.bind(this);
    this.selectBoxSubjectHandleChange = this.selectBoxSubjectHandleChange.bind(this);

    this.selectBoxTopicHandleChange = this.selectBoxTopicHandleChange.bind(this);

    this.categoryCopyShow = this.categoryCopyShow.bind(this);
    this.categoryCopyHide = this.categoryCopyHide.bind(this);
    this.copyCategoryDetails = this.copyCategoryDetails.bind(this);
    this.onEnableSync = this.onEnableSync.bind(this); 
    this.onHandleRedirect = this.onHandleRedirect.bind(this)
  }
  superAdminSyncCatValidation ()  {
    this.setState({
      AllCatForSuperadmin: !this.state.AllCatForSuperadmin
    });
  }
  addBreadCrumbs = () => {
    this.props.replaceBreadCrumb([
      {
        name: 'Subjects',
        type: 'Subjects',
        onclickPath: 'subjects'+
        '?archive_mode='+
        this.state.archive_mode+
        '&archive_id='+
        this.state.archive_id
      },
      {
        name: this.state.subject_name,
        type: 'Subjects',
        onclickPath:
          'topics?subject_id=' +
          this.state.subject_id +
          '&subject_name=' +
          this.state.subject_name+
          '&archive_mode='+
          this.state.archive_mode+
          '&archive_id='+
          this.state.archive_id
      },
      {
        name: this.state.topic_name,
        type: 'Topics',
        onclickPath:
          'category?subject_id=' +
          this.state.subject_id +
          '&subject_name=' +
          this.state.subject_name +
          '&topic_id=' +
          this.state.topic_id +
          '&topic_name=' +
          this.state.topic_name+
          '&archive_mode='+
          this.state.archive_mode+
          '&archive_id='+
          this.state.archive_id
      }
    ]);
  };
  componentDidUpdate() {
    this._refresh();
    this.addBreadCrumbs();
  }
  
  _refresh(){
    // refresh if subject id or topic or category is changed in url
    
    let paramsSubjectId = this.props.location.query.subject_id
    let paramsTopicId = this.props.location.query.topic_id
    if (this.state.subject_id !== paramsSubjectId  || this.state.topic_id !== paramsTopicId) {
      this.state.subject_id = this.props.location.query.subject_id
      this.state.subject_name = this.props.location.query.subject_name
      this.state.topic_id = this.props.location.query.topic_id
      this.state.topic_name = this.props.location.query.topic_name
      this.loadCategories();
      this.getCountOfTCSQ();
      this.helpTextModel = new HelpText();
    }

  }
  componentWillUnmount() {
    this.removeBreadCrumbs();
  }




  removeBreadCrumbs = () => {
      this.props.replaceBreadCrumb([
      ]);     
    

  };

  loadCategories = () =>{
    this.setState({ loading: true });

    var sub_id = parseInt(this.state.subject_id, 10);
    var top_id = parseInt(this.state.topic_id, 10);
    let payload = {
      topic_id: top_id,
      subject_id: sub_id
    };

    // Use cached instructor subjects from localStorage instead of API calls
    let subjectsByIns = this.state._userAccessDetails?.subjectsbyInstructor || {};
    let currSubject = subjectsByIns[sub_id] === true;

    if(this.state.archive_mode === 'true'){
      payload['archive_id'] = this.state.archive_id;
      payload['archive_mode'] = true;
    }
    ApiRequestService({
      method: 'post',
      url: '/getAllCategories',
      data: payload
    }).then(res => {
      console.debug('Get All Categories res :', res.data.data);

      if (res && res.data && res.data.data?.topic_explanation_count) {
        this.setState({
          topicExplanationCount: res.data.data?.topic_explanation_count,
        })
      }

      if (res && res.data && res.data.data?.topic_tutorial_count) {
        this.setState({
          topicTutorialsCount: res.data.data?.topic_tutorial_count,
        })
      }

      if (res.data.data.category_names !== null) {
          this.setState({
            categories: res.data.data.category_names,
            instSubjects : subjectsByIns,
            currSubject:currSubject,
            loading: false,
            lastComputedAt: res.data.data.last_computed_at?.includes("1970") ? null : res.data.data.last_computed_at,
          });
          Object.keys(subjectsByIns).forEach((tempSubjectId)=>{
            this.state.subjects.forEach((subject)=>{
              if(subject.subject_id === parseInt(tempSubjectId)){
                this.state.instAllSubjects.push(subject)
              }
            })
          })
        }else{
          this.setState({
            instSubjects : subjectsByIns,
            currSubject:currSubject,
            loading: false,
            lastComputedAt: null
          });
        }
    }).catch(err =>{
      this.setState({loading: false
      });
      this.hide();
      NotificationManager.error(err, 'ERROR', 3000);
    });
  }
  componentWillMount() {
    this.loadCategories();
    this.getCountOfTCSQ();
    this.getSyncSwitchAccess()
    this.helpTextModel = new HelpText();
  }

  onHandleRedirect = (category) => {

    let subjectRedirect = parseInt(this.state.subject_id)
    if ((this.state.instSubjects && !(this.state.instSubjects[subjectRedirect] === true))  || this.appProperties.enableLTI ) {
      let navigatePage =
          `subCategory?topic_id=${this.state.topic_id}` +
          `&subject_id=${this.state.subject_id}` +
          `&category_id=${category.category_id}` +
          `&subject_name=${this.state.subject_name}` +
          `&topic_name=${this.state.topic_name}` +
          `&category_name=${category.category_name}` +
          `&archive_mode=${this.state.archive_mode}` +
          `&archive_id=${this.state.archive_id}`
                
      this.setState({
        loading: true,
        redirectLoading:true
      });
      //fetch  source redirect url 

     let  payload = {
        subject_id: subjectRedirect
      }
      ApiRequestService({
        method: 'post',
        url: '/sourceUnivUrl',
        data: payload
      })
      .then(res => {
        if (res.data.message !== null && res.data.message !== '') {
          NotificationManager.error(res.data.message, 'ERROR', 3000);
          this.setState({
            loading: false,
            redirectLoading:false
          });
        }
        
        
        if(res.data && res.data.status === 0){
          let response = res.data.data
          let soucreBase= response.REACT_APP_URL
          let sourceURL = soucreBase + navigatePage
          
          //navigate to source univ
          window.open(sourceURL, '_blank');

          //navigate current Page
          browserHistory.push(this.appProperties.baseFolder + navigatePage);
          this.setState({
            loading: false,
            redirectLoading:false
          });
        }

        
      }).catch((err)=> {
        console.debug("error from source univ url",err)

        this.setState({
          loading: false,
          redirectLoading:false
        });
      })

    }

  }

  getCountOfTCSQ = () => {
    var sub_id = parseInt(this.state.subject_id, 10);
    var top_id = parseInt(this.state.topic_id, 10);
    this.setState({ countLoading: true });
    const payload = {
      subject_id : sub_id,
      topic_id : top_id ,
      category_id : 0,
      subcategory_id : 0 
    }

    ApiRequestService({
      method: 'post',
      url: '/getCountOfTCSQ',
      data: payload
    }).then(res => {
      if(res.data !== undefined && res.data !== null && res.data.data.CountOfTCSQ !== undefined && res.data.data.CountOfTCSQ !== null){
        console.debug(res);
        console.debug('getCountOfTCSQ State: ');
        this.setState({
          countOfTCSQ : res.data.data.CountOfTCSQ,
          explanationCountMap: res.data.data.ExplanationCountMap,
        });
      }
    }).finally(() => {
      this.setState({ countLoading: false });
    });
  }


 

  loadSubjectData() {
    //let answerIndex = 0;
    let payload = {};
    if(this.state.archive_mode === 'true'){
      payload['archive_id'] = this.state.archive_id;
      payload['archive_mode'] = true;
    }
    ApiRequestService({
      method: 'post',
      url: '/getAllSubjects',
      data:payload
    }).then(res => {
      //console.debug(res.data.data.subject_names);
      if(res !== undefined && res !== null &&
        res.data !== undefined && res.data !== null && 
        res.data.data !== undefined && res.data.data !== null &&
        res.data.data.subject_names !== undefined && res.data.data.subject_names !== null  ){
          this.setState({
            subjects: res.data.data.subject_names,
            
          });      
          console.debug("res.data.data.subject_names",res.data.data.subject_names);
        }
      
    });
  }


  loadTopicData(sub_id) {
    //console.debug("loadTopicData");
    this.setState({ subjectId: sub_id });
    var tempTopic = [];
    let payload = {
      // subject_id: this.state.subject_id
      subject_id: sub_id
    };
    if(this.state.archive_mode === 'true'){
      payload['archive_id'] = this.state.archive_id;
      payload['archive_mode'] = true;
    }
    //console.debug("Subject id : ",payload);
    ApiRequestService({
      method: 'post',
      url: '/getAllTopics',
      data: payload
    }).then(res => {
      

      if (res.data.data && res.data.data.topic_names !== null) {
        tempTopic = res.data.data.topic_names;
        this.setState({
          topics: tempTopic,
          showTopicsSelectBox: true,
          
        });
        //this.selectBoxTopicHandleChange(this.createFakeEvent(tempTopic[0].topic_id));
      } else {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
        this.setState({
          topics: [],
          
        });
        // this.selectBoxTopicHandleChange(this.createFakeEvent(-1));
      }
    });
    
    //this.setState({ loading: false });
  }

  selectBoxTopicHandleChange(event) {
    console.debug('selectBoxTopicHandleChange =', event.target.value);
    
    var top_id = parseInt(event.target.value, 10);
    this.setState({
      showCategorySelectBox: false,
      showSubCategorySelectBox: false,
      topicId:top_id,
    });
    
    //this.loadCategory(sub_id, top_id);
  }

  // loadCategory(sub_id, top_id) {
  //   this.setState({ topicId: top_id });
  //   const payload = {
  //     topic_id: top_id,
  //     subject_id: sub_id
  //   };
  //   //console.debug("Topic id : ",payload);
  //   ApiRequestService({
  //     method: 'post',
  //     url: '/getAllCategories',
  //     data: payload
  //   }).then(res => {
  //     console.debug('Get All Categories res :', res.data.data.category_names);
  //     if (res.data.data.category_names !== null) {
  //       this.setState({
  //         categories: res.data.data.category_names,
  //         showCategorySelectBox: true
  //       });

  //       //this.selectBoxCategoryHandleChange(this.createFakeEvent(res.data.data.category_names[0].category_id));
  //     } else {
  //       this.setState({
  //         categories: []
  //       });
  //       // this.selectBoxCategoryHandleChange(this.createFakeEvent(-1));
  //     }
  //   });
  // }


  addCategory() {
    /*141 Subject, Topic, Cat, Sub Cat Names should not allow empty or empty space*/
    if (
      this.state.temp_category.category_name === null ||
      this.state.temp_category.category_name.trim() === ''
    ) {
      alert('Please enter a valid "Category name"');
      return;
    }
    this.setState({ actionLoading: true });
    console.log('Add category :' , this.state.temp_category);
    var sub_id = parseInt(this.state.subject_id, 10);
    var top_id = parseInt(this.state.topic_id, 10);
    const payload = {
      category_name: this.state.temp_category.category_name.trim(),
      category_label: this.state.temp_category.category_label.trim(),
      topic_id: top_id,
      subject_id: sub_id
    };
    ApiRequestService({
      method: 'post',
      url: '/addCategory',
      data: payload
    }).then(res => {
      // var tempErrorMessage ="";
      // var tempErrorType = "";

      if (res.data.message !== null && res.data.message !== '') {
        // Bug id #143 fixed
        //this.setState({ loading: false });
        this.hide();
        NotificationManager.error(res.data.message, 'ERROR', 3000);
        return;
      }

      if (res.data.data !== null) {
        console.debug('Add Category Response2 : ', res.data.data.category_name);
        this.state.categories.push({
          category_name: res.data.data.category_name.trim(),
          category_label:res.data.data.category_label,
          category_id: res.data.data.category_id,
          subject_id:sub_id,
          enable_sync: res.data.data.enable_sync,
          sync_status:res.data.data.sync_status,  
          sync_validation:res.data.data.sync_validation,  
        });
        this.state.countOfTCSQ.push({
          number_of_categories: 0,
          number_of_subcategories:0,
          number_of_questions:0
        })
        if (res.data.data.category_names !== null) {
          this.setState({
            categories: this.state.categories,
            countOfTCSQ:this.state.countOfTCSQ,
          });
        }
      }
      this.hide();
    }).finally(() => {
      this.setState({
        actionLoading: false
      })
    });
   // this.getCountOfTCSQ();
    
    
    
  }

  // errorMessageHide(){
  //     console.debug("errorType");
  //     var tempErrortype = "";
  //     var tempErrorMessage = "";
  //     this.setState({
  //         errorMessage: tempErrortype,
  //         errorType:tempErrortype,
  //     })

  // }

  onEnableSync = (index)=>{
    this.setState({loading:true});
    const payload = {
      category_id:this.state.categories[index].category_id,
      topic_id:this.state.categories[index].topic_id,
      subject_id: this.state.categories[index].subject_id,
      enable_sync:true
    };
      // LTI sync disable
      if( this.appProperties.enableLTI ) {
        this.setState({
          loading: false
        });
        return
      }
    
      //check empty category
      let subCountOfTCSQ = this.state.countOfTCSQ[index]
      if (subCountOfTCSQ.number_of_subcategories == 0) {
        NotificationManager.error(
          'Error',
          'Unable To Sync Empty Category. Please Add  Or Subcategory And Try Again',
          5000
        );
  
        this.setState({
          loading: false
        });
        return
      }
    ApiRequestService({
      method: 'post',
      url: '/sync/enableSyncCategory',
      data: payload
    })
      .then(res => {
        if (res.data.message !== null && res.data.message !== '') {
          NotificationManager.error(res.data.message, 'ERROR', 3000);
          this.setState({
            loading: false
          });
        }
        if(res.data && res.data.status === 0){
          let tempArray = [...this.state.categories];
          tempArray[index].enable_sync = payload.enable_sync;
          this.setState({
            categories:tempArray,
            loading: false
          });
        } 
      })
      .catch(error => {
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            'Unauthorized',
            'You are not authorized to edit topic',
            5000
          );
        }
        this.setState({
          loading: false
        });
      });
  }
  onDisableSync = (index)=>{
    this.setState({loading:true});
    const payload = {
      category_id:this.state.categories[index].category_id,
      topic_id:this.state.categories[index].topic_id,
      subject_id: this.state.categories[index].subject_id,
      enable_sync:false
    };
    // LTI sync disable
    if( this.appProperties.enableLTI ) {
      this.setState({
        loading: false
      });
      return
    }
    
    ApiRequestService({
      method: 'post',
      url: '/sync/enableSyncCategory',
      data: payload
    })
      .then(res => {
        if (res.data.message !== null && res.data.message !== '') {
          NotificationManager.error(res.data.message, 'ERROR', 3000);
          this.setState({
            loading: false
          });
        }

        if(res.data && res.data.status === 0){

          // Refused: a library matrix that is syncing depends on this category.
          // Nothing was written, so the toggle stays on and the matrices
          // holding it there are named.
          const usage = res.data.data;
          if (usage && usage.valid === false) {
            this.setState({
              blockingLibraryMatrices: usage.library_matrices || [],
              loading: false
            });
            return;
          }


          let tempArray = [...this.state.categories];
          tempArray[index].enable_sync = payload.enable_sync;
          this.setState({
            categories:tempArray
          });
          this.loadCategories();
        }

        
      })
      .catch(error => {
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            'Unauthorized',
            'You are not authorized to edit topic',
            5000
          );
        }
        this.setState({
          loading: false
        });
      });
  }


  editCategory(id) {
    this.setState({
      temp_category: {...this.state.categories[id]},
      temp_id: id,
      addMode: false
    });
    this.show(false);
  }

  updateCategory() {
    this.setState({ actionLoading: true });
    console.debug('Editing category :' + this.state.temp_category.category_id);
    var sub_id = parseInt(this.state.subject_id, 10);
    var top_id = parseInt(this.state.topic_id, 10);
    const payload = {
      // this.state.temp_category
      category_name: this.state.temp_category.category_name,
      category_label: this.state.temp_category.category_label,
      category_id: this.state.temp_category.category_id,
      subject_id: sub_id,
      topic_id: top_id
    };
    ApiRequestService({
      method: 'post',
      url: '/updateCategory',
      data: payload
    }).then(res => {
      console.debug('UpdateCategory Response :', res);
      if (res && res.data && res.data.message) {
        let message = "Something went wrong";
        if (res.data.message === "duplicate name") {
           message = "Category with this name already exits. Please give a different name";
        }
        NotificationManager.error(message, "", 5000);
        return;
      }
      let tempCategories = this.state.categories;
      let category = {...this.state.temp_category};
      category.category_name = category.category_name.trim();
      tempCategories[this.state.temp_id] = category;
      this.setState({
        categories: tempCategories,
      });
      this.hide();
    }).finally(() => {
      this.setState({
        actionLoading: false,
      })
    });
  }

  getSyncSwitchAccess = () => {
    if ( this.state.userprofilerole === ADMIN_USER_ROLE){
        ApiRequestService({
          method:'post',
          url:'/syncSwitch'
        }).then(res => {
          let syncAccess = res.data.data
 
          if (syncAccess) {

            this.setState({
              synloading: false,
              syncAccess:true
            });
          }
        }).finally(err => {
          this.setState({
            synloading:false
          })
        })
  
    }
  }

  deleteCategory(id) {
    this.setState({ loading: true });
    console.debug(
      'Deleting category i:' +
        id +
        ' id: ' +
        this.state.categories[id].category_id
    );
    var sub_id = parseInt(this.state.subject_id, 10);
    var top_id = parseInt(this.state.topic_id, 10);
    const payload = {
      category_id: this.state.categories[id].category_id,
      topic_id: top_id,
      subject_id: sub_id,
      archive_mode:this.state.archive_mode
    };
    ApiRequestService({
      method: 'post',
      url: '/deleteCategory',
      data: payload
    })
      .then(res => {
        console.debug(res);
        //window.localtion.reload();
        this.state.categories.splice(id, 1);
        console.debug('Spliced Array', this.state.categories);
        this.state.countOfTCSQ.splice(id, 1);
        this.setState({
          countOfTCSQ:this.state.countOfTCSQ,
          categories: this.state.categories,
          loading: false,

          showDeleteDialog: false,
          deleteData: null,
          deleteIndex: -1,
        });
      })
      .catch(error => {
        //bug-tracker#162

        console.error('Error When Deleting ', error);
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            'Unauthorized',
            'You are not authorized to delete category',
            5000
          );
        }
        this.setState({
          loading: false
        });
      });
  }
  changeCategoryName(e) {
    let newCategory = this.state.temp_category;
    newCategory.category_name = e;
    this.setState({ temp_category: newCategory });
  }
  changeCategoryLabel(e) {
    let newCategory = this.state.temp_category;
    newCategory.category_label = e;
    this.setState({ temp_category: newCategory });
  }
  tabOnChange(e) {
    console.debug('tab name = ', e);
    // if(e == 'Questions'){
    //     this.state.categoryDiv = false
    //     this.state.questionsDiv = true
    //     this.state.explanationDiv = false
    //     this.state.mode = 0
    // }else
    if (e === 'Category') {
      this.setState({
        categoryDiv: true,
        questionsDiv: false,
        explanationDiv: false,
        mode: QUESTION_STATE_MODE
      });
    } else if (e === 'Explanation') {
      this.setState({
        categoryDiv: false,
        questionsDiv: false,
        explanationDiv: true,
        mode: EXPLANATIONS_STATE_MODE
      });
    }  else if (e === "Tutorials") {
      this.setState({
        mode: TUTORIALS_STATE_MODE,
      })
    }
  }

  show = isCategoryEnable => {
    //this.errorMessageHide();
    if (isCategoryEnable) {
      this.setState({
        temp_category: {
          category_name: '',
          category_label: '',
          category_id: ''
        }
      });
    }

    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({
      visible: false,
      addMode: true
    });
  };
  subjPage() {
    browserHistory.push(this.baseFolder + 'subjects');
  }

  delete = id => {

    this.setState({
      showDeleteDialog: true,
      deleteData: {
          ...this.state.categories[id],
          deleteType: 'Category',
      },
      deleteIndex: id,
    });

    // confirmAlert({
    //   title: 'Are you sure want to delete this Category?',
    //   message: 'Press Confirm to submit',

    //   cancelLabel: 'Confirm',
    //   confirmLabel: 'Cancel',
    //   onCancel: () => this.deleteCategory(id)
    // });
  };
  topcPage = () => {
    browserHistory.push(
      this.baseFolder +
        'topics?subject_id=' +
        this.state.subject_id +
        '&subject_name=' +
        this.state.subject_name
    );
  };

  categoryMoveHide () {

    this.setState({
      moveCategoryVisible: false,
      
    });
  };
  categoryMoveShow(categoryId) {
    //this.errorMessageHide();
    var tempMoveCategoryId = parseInt(categoryId, 10);
    this.setState({ moveCategoryVisible: true,
      moveCategoryId: tempMoveCategoryId });
    this.loadSubjectData();
    this.loadTopicData(this.state.selectBoxSubjectDefaultId);
  };

  moveCategoryDetails(){
    console.log("moveCategoryDetails");
    
    
    var sub_id = parseInt(this.state.subjectId, 10);
    var top_id = parseInt(this.state.topicId, 10);
    var moveCategoryId =  parseInt(this.state.moveCategoryId, 10);
    var previousSubjectId = parseInt(this.props.location.query.subject_id, 10);
    var previousTopicId = parseInt(this.props.location.query.topic_id, 10);
    
    const payload = {
      
      topic_id: top_id,
      subject_id: sub_id,
      category_id:moveCategoryId,
      previous_topic_id:previousTopicId,
      previous_subject_id:previousSubjectId,
      is_copying: true,
    };
    this.setState({ loading: true });
    console.log(payload)
    ApiRequestService({
      method: 'post',
      url: '/moveCategory',
      data: payload
    }).then(res => {
      console.debug('Move Categories res :', res);
     
      if(res !== undefined && res !== null &&
        res.data !== undefined && res.data !== null  &&
        res.data.message !== undefined && res.data.message !== null 
        && res.data.message !== "" ){
        NotificationManager.error(res.data.message, 'ERROR', 3000);  
      }else{
        NotificationManager.success("Moved Successfully","SUCCESS",5000);
      }

      this.setState({ loading: false });
      this.categoryMoveHide();  
      this.loadCategories();
      this.getCountOfTCSQ();
      //this.topcPage();   
      
    });


  }

  selectBoxSubjectHandleChange(event) {
    // console.debug( "selectBoxSubjectHandleChange =",event.target.value);
    //this.setState({selectBoxTopicValue: event.target.value});

    var sub_id = parseInt(event.target.value, 10);
    this.setState({
      subjectId: sub_id,
      showTopicsSelectBox: false,
      selectBoxTopicDefaultId: 0
    });

    this.loadTopicData(sub_id);
  }

  copyCategoryDetails(){
    this.setState({ loading: true });
    if (this.state.instSubjects[this.state.subjectId] === true){
      var sub_id = parseInt(this.state.subjectId, 10);
      var top_id = parseInt(this.state.topicId, 10);
      var previousSubjectId = parseInt(this.props.location.query.subject_id, 10);
      var previousTopicId = parseInt(this.props.location.query.topic_id, 10);
      var previousCategoryId =  parseInt(this.state.copyCategoryId, 10);
    }else{
      this.setState({ loading: false });
      return
    }
    
    const payload = {
      topic_id: top_id ||parseInt(this.props.location.query.topic_id, 10),
      subject_id: sub_id,
      previous_topic_id:previousTopicId,
      previous_subject_id:previousSubjectId,
      previous_category_id:previousCategoryId,
      category_name:this.state.copyCategoryName,
      is_copying: true,
    };

    console.log("copy Category payload is : ",payload)

    ApiRequestService({
      method: 'post',
      url: '/copyCategory',
      data: payload
    }).then(res => {
      console.debug('copy Categories res :', res);
      if(res !== undefined && res !== null &&
        res.data !== undefined && res.data !== null  &&
        res.data.message !== undefined && res.data.message !== null 
        && res.data.message !== "" ){
        NotificationManager.error(res.data.message, 'ERROR', 3000);  
      }else{
        this.loadCategories();
        this.getCountOfTCSQ();
        NotificationManager.success("Successfully started to copy the Category.")
        
      }
      this.setState({ loading: false });
      this.categoryCopyHide();          
    });
  
  }

  categoryCopyShow(subcategoryId, subcategoryName) {
    var tempCopyCategoryId = parseInt(subcategoryId, 10);
    this.setState({
      copyCategoryVisible: true,
      copyCategoryId: tempCopyCategoryId,
      copyCategoryName:subcategoryName
    });
    this.loadSubjectData();
    this.loadTopicData(this.state.selectBoxSubjectDefaultId);
  };

  categoryCopyHide () {
    this.setState({
     copyCategoryVisible: false,
          
    });
  };

  changeCopyCategoryName = (e) => {
    let tempCopyCategoryName = e;
    this.setState({ copyCategoryName: tempCopyCategoryName });
  }

  isEnterPressed(event){
    var code = event.keyCode || event.which;
    if(code === 13) { //13 is the enter keycode
      if (this.state.addMode) {
       this.addCategory();
      } else{
       this.updateCategory();
      }
    }
  }

  downloadCategoryCSV() {
    console.debug("Hello world");
  }

  calculateAccuracyAndTime = () => {

    var sub_id = parseInt(this.state.subject_id, 10);
    var top_id = parseInt(this.state.topic_id, 10);
    
    let payload = {
      subject_id: sub_id,
      topic_id: top_id,
      type: "Category"
    }
    this.setState({ calculationLoading: true });
    ApiRequestService({
      method: 'post',
      url: '/calculateAccuracyAndTime',
      data: payload
    }).then(res => {
         if (res && res.data && res.data.status === 0) {
          let accuracyTimeArr = res.data.data.accuracy_time_arr ? res.data.data.accuracy_time_arr : [];
          let updatedCategories = this.state.categories.map(category => {
            let accuracyTimeData = accuracyTimeArr.find(acc => {
              return acc.subject_id === category.subject_id &&
              acc.topic_id === category.topic_id &&
              acc.category_id === category.category_id
            })
            if (accuracyTimeData) {
              return {
                ...category,
                avg_time: accuracyTimeData.time,
                difficulty_level: accuracyTimeData.accuracy
              }
            }
            return category;
          });
          this.setState({
            categories: updatedCategories,
            lastComputedAt: new Date(),
          })

          NotificationManager.success("Calculation of accuracy and time completed successfully!", "", 3000);
        } else {
          NotificationManager.error("Something went wrong", "", 3000);
        }
      }).finally(() => {
        this.setState({ calculationLoading: false });
      });
  }


  render() {
    
    let button = null;
    if (this.state.addMode) {
      button = (
        <Button disabled={this.state.actionLoading} raised primary onClick={this.addCategory}>
          {this.state.actionLoading ? <BeatLoader size={12} color='#bb0000' /> : "Add Category"}
        </Button>
      );
    } else {
      button = (
        <Button disabled={this.state.actionLoading} raised primary onClick={this.updateCategory}>
          {this.state.actionLoading ? <BeatLoader size={12} color='#bb0000' /> : "Update Category"}
        </Button>
      );
    }

  
    var cancelButton = (
      <Button disabled={this.state.actionLoading} flat primary onClick={this.hide}>
        Cancel
      </Button>
    );

    const actions = [];
    actions.push(cancelButton);
    actions.push(button);
    


    var moveModifyButton = (
      <button style={styles.addButton} onClick={this.moveCategoryDetails}>
        Move
      </button>
    );
    var moveCancelButton = (
      <button style={styles.cancelButton} onClick={this.categoryMoveHide}>
        Cancel
      </button>
    );
    const moveActions = [];
    moveActions.push(moveModifyButton);
    moveActions.push(moveCancelButton);


    const copyActions = [];
    var copyButton = (
      <Button style={styles.addButton} onClick={this.copyCategoryDetails}>
        Copy
      </Button>
    );
    var copyCancelButton = (
      <Button style={styles.cancelButton} onClick={this.categoryCopyHide}>
        Cancel
      </Button>
    );
    copyActions.push(copyButton);
    copyActions.push(copyCancelButton);

    var tbody;
    if (this.state.categories !== null) {
      console.debug('Cat data set1: ', this.state.categories);
      tbody = (
        <tbody className="subjectTableBodyClass">
          {this.state.categories.map((category, i) => {
            if (category.sync_validation || this.state.AllCatForSuperadmin) {
              let key = `${category.subject_id}_${category.topic_id}_${category.category_id}`
               return (
                 
                 <TableRow
                   key={category.category_id}
                   data={category}
                   pushId={'category'}
                   id={category.category_id}
                   name={category.category_name}
                   custom_label={category.category_label}
                   difficulty_level={category.difficulty_level}
                   avg_time={category.avg_time}
                   title={'Categories'}
                   type={''}
                   url={
                     'subCategory?topic_id=' +
                     this.state.topic_id +
                     '&subject_id=' +
                     this.state.subject_id +
                     '&category_id=' +
                     category.category_id +
                     '&subject_name=' +
                     this.state.subject_name +
                     '&topic_name=' +
                     this.state.topic_name +
                     '&category_name=' +
                     category.category_name+
                     '&archive_mode='+
                     this.state.archive_mode+
                     '&archive_id='+
                     this.state.archive_id
                   }
                   countLoading={this.state.countLoading}
                   onEditClick={() => this.editCategory(i)}
                   onDeleteClick={() => this.delete(i)}
                   onMoveCategoryClick={() => this.categoryMoveShow(category.category_id)}
                   show_archive_actions={this.state.archive_mode}
                   instructorSubject={(this.state.instSubjects && this.state.instSubjects[category.subject_id] === true) }
                   onArchiveRestoreClick={()=>this.onArchiveRestoreClick(category)}
                   onCopyClick={()=>this.categoryCopyShow(category.category_id, category.category_name)}
                   countOfTCSQ={this.state.countOfTCSQ !== undefined && this.state.countOfTCSQ !== null ? this.state.countOfTCSQ[i] : null}
                   explanationMap={this.state.explanationCountMap ? this.state.explanationCountMap[key] : {}}
                   syncEnabled={category.enable_sync}
                   rowIndex={i}
                   onHandleRedirect={()=> this.onHandleRedirect(category)}
                   onEnableSync={() => this.onEnableSync(i)}
                   onDisableSync={() => this.onDisableSync(i)}
                   syncSwitch={this.state.syncAccess}
                   created_by={category.created_by}
                 />
               )

             }
            })}
        </tbody>
      );
    }

    return (
      (this.state.loading) ?

      <div>
          {
             this.state.redirectLoading ? <p style={{ 
              display: "flex" ,justifyContent: "center",
              color:"#bb0000",fontSize:"20px",fontWeight:"500"
              }}>
                Redirecting to Source University, Please wait...</p> : " "
          }

        <div   style={{ marginTop:"-261px"}}  >
          <LoadingSpinner loading={this.state.loading} />
        </div>
      </div>
      :
      <SecureShow targetRole={1}>

          <QBSyncInUseByLibraryDialog
            scope="category"
            libraryMatrices={this.state.blockingLibraryMatrices}
            onClose={() => this.setState({blockingLibraryMatrices: null})}
          />

          <QBDeleteDialog 
            showDialog={this.state.showDeleteDialog}
            data={this.state.deleteData}
            handleClose={() => this.setState({showDeleteDialog: false, deleteData: null, deleteIndex: -1})}
            handleDelete={() => {
              if (this.state.deleteIndex > -1) {
                this.deleteCategory(this.state.deleteIndex);
              }
            }}
          />

        <div className="categoryClassContainer" style={{ marginTop:"120px"}}>

          <div style={styles.catTitle}>
            <strong>Topic</strong> - {this.state.topic_name}
            {
            this.state.readOnly
            ?
            null
            :
            <div style={styles.syncvalidationSwitch}>
                {
                    this.state.syncAccess ? 
                    <div>
                      
                    <SelectionControl 
                    id={"syncsubhideswitch"}
                    type="switch"
                    name="syncHide"
                    label={null}
                    checked={this.state.AllCatForSuperadmin}
                    onChange={() => this.superAdminSyncCatValidation()}
                    style={{float: 'none', display: 'inline-block',top:"-8px",position:"relative"}}
                    data-tip data-for='test-mode-sync'
                    />
                    <ReactTooltip id={'test-mode-sync'} type='light' className='tool-tip'>
                      <span>{'View As super Admin to show all Category'}</span>
                    </ReactTooltip> 
                    </div>
                    : ""
                  }
            <div style={this.state.currSubject ?  styles.floatRight : {display:"none"} }>
            {this.state.mode === QUESTION_STATE_MODE && (!this.appProperties.enableLTI)? (
              <div style={{display: 'flex', gap:'8px'}}>
                <Button 
                  style={{
                    display: this.state.userprofilerole === ADMIN_USER_ROLE ? 'block' : 'none'
                  }}
                  tooltipLabel={
                    <div>{this.state.lastComputedAt ? 
                      `Last computed at: ${moment(this.state.lastComputedAt).format('DD/MM/YYYY hh:mm a')}` : "N/A"}
                    </div>
                  }
                primary flat onClick={this.calculateAccuracyAndTime}
                    disabled={this.state.calculationLoading}>
                      {this.state.calculationLoading ? <span>
                        <BeatLoader color={'#bb0000'} loading={true} size={10} />
                      </span> : "Calculate accuracy and time"}
                    </Button>
                <Button className="archive-button" primary raised
              style={{float: "right"}}
                onClick={() => this.show(true)}>
                  Add a New Category
              </Button>
              </div>
            ) : (
                ''
              )}
            </div>
            </div>
            }
            <div style={{
              width:'400px',
              marginTop:'16px'
            }}>
              <CustomSegmentedControl
                  options={[
                    { label: 'Categories', value: 'Category', default: true },
                    { label: (
                      <div>
                        <ReactTooltip  effect='solid' id='explanation' type='light' className='tool-tip'>
                          <span>
                          View explanations for this topic
                          </span>
                        </ReactTooltip>
                        <div data-tip data-for='explanation'>Topic Explanations ({this.state.topicExplanationCount})</div>
                    </div>
                    ), value: 'Explanation' },
                    { label: (
                        <div>
                          <div data-tip data-for='tutorials'>Topic Tutorials ({this.state.topicTutorialsCount})</div>
                          <ReactTooltip  effect='solid' id='tutorials' type='light' className='tool-tip'>
                          <span>
                            View tutorials for this topic
                          </span>
                        </ReactTooltip>
                      </div>
                      ), value: 'Tutorials' }
                  ]}
                  setValue={(newValue )=> this.tabOnChange(newValue)}
                  style={{
                    ...styles.categorySegmentedControl,
                    minWidth:'800px',
                  }}
                />
            </div>
            {/* <div style={styles.categorySegemntStyle} className="topicSegmentControlContainer" id="qb-category-segment">
              <SegmentedControl className="topicsSegmentedControlClass"
                name="oneDisabled"
                options={[
                  { label: 'Categories', value: 'Category', default: true },
                  // { label: "Questions", value: "Questions" },
                  { label: 'Explanations', value: 'Explanation' }
                ]}
                setValue={(newValue )=> this.tabOnChange(newValue)}
                style={styles.categorySegmentedControl} //
              />
            </div> */}
          </div>
          <div>
            <DialogContainer
                  id="simple-action-dialog"
                  visible={this.state.moveCategoryVisible}
                  onHide={this.categoryMoveHide}
                  actions={moveActions}
                  title="Move Category"
                  width="500px"
                >
                <table >
                  <tr>
                <td>
                  
                 <SelectBox
                      labeltxt="Subjects"
                      columns={this.state.userprofilerole === 2 ?this.state.subjects:
                        this.state.instAllSubjects}
                      keys={['subject_id', 'subject_name']}
                      className="create-question-select-box"
                      selectBoxcallBack={this.selectBoxSubjectHandleChange}
                      defaultId={this.state.selectBoxSubjectDefaultId}
                      //selectBoxDisabled={controlEnable}
                    />
                </td>
                <td>
                  
                <SelectBox
                      labeltxt="Topics"
                      columns={this.state.topics}
                      keys={['topic_id', 'topic_name']}
                      className="create-question-select-box"
                      selectBoxcallBack={this.selectBoxTopicHandleChange}
                      defaultId={this.state.selectBoxTopicDefaultId}
                      //selectBoxDisabled={controlEnable}
                      ///bug-tracker#156
                      style={{
                        visibility: this.state.showTopicsSelectBox
                          ? 'visible'
                          : 'hidden'
                      }}
                    />
                     </td>
                    </tr>
                    </table>
            </DialogContainer>
          </div>
          
          <div>
            <DialogContainer
                  id="simple-action-dialog"
                  visible={this.state.copyCategoryVisible}
                  onHide={this.categoryCopyHide}
                  actions={copyActions}
                  title="Copy Category"
                  width="700px"
                >
                  <div>Name{' '}
                    <TextField
                    id="catId"
                      type="text"
                      name="catagory_name"
                      value={
                        this.state.copyCategoryName || ''
                      }
                      onChange={this.changeCopyCategoryName}
                      style={categoryStyles.dialogText}
                    />
                  </div><br/>
                  <table>

                  <tr>
                    <td>
                      <SelectBox
                        labeltxt="Subjects"
                        columns={this.state.userprofilerole === 2 && this.state.instSubjects[this.state.subject_id] === true ? this.state.subjects:
                          this.state.instAllSubjects}
                        keys={['subject_id', 'subject_name']}
                        className="create-question-select-box"
                        selectBoxcallBack={this.selectBoxSubjectHandleChange}
                        defaultId={this.state.selectBoxSubjectDefaultId}
                      />
                    </td>
                    <td>
                      <SelectBox
                        labeltxt="Topics"
                        columns={this.state.topics}
                        keys={['topic_id', 'topic_name']}
                        className="create-question-select-box"
                        selectBoxcallBack={this.selectBoxTopicHandleChange}
                        defaultId={this.state.userprofilerole === 2 && this.state.instSubjects[this.state.subject_id] === true ? this.state.selectBoxTopicDefaultId: ''}
                        ///bug-tracker#156
                        style={{
                          visibility: this.state.showTopicsSelectBox
                            ? 'visible'
                            : 'hidden'
                        }}
                      />
                      </td>
                    </tr>
                  </table>
            </DialogContainer>
          </div>

          <div style={{float:'right', marginRight:'1rem', marginTop:"6px",}}>
            <CSVLink data={[
              ['ID', 'Name', 'Label', '# of Subcategories', '# of Questions', 'Accuracy (%)', 'Time (Sec)'],
              ...this.state.categories?.map(cat => {

                let count =  this.state.countOfTCSQ.find(ele => (
                  `${ele.subject_id}_${ele.topic_id}_${ele.category_id}` === `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`
                ));

                return [
                  cat.category_id,
                  cat.category_name,
                  cat.category_label,
                  count ? count.number_of_subcategories : 0,
                  count ? count.number_of_questions : 0,
                  cat.difficulty_level,
                  cat.avg_time,
                ]
              })
            ]}  target='_blank' enclosingCharacter='"' filename={`Categories list for ${this.state.topic_name}.csv`}>
                <Button flat primary iconChildren="cloud_download">Download CSV</Button>
            </CSVLink>
          </div>
          

          {this.state.mode === EXPLANATIONS_STATE_MODE ? 
            <ExplanationsList
              subject_id={this.state.subject_id}
              topic_id={this.state.topic_id}
              category_id={0}
              subcategory_id={0}
              loading={this.state.loading}
              archive_id={this.state.archive_id}
              archive_mode={this.state.archive_mode}
              readOnly={this.state.readOnly}
              updateTotalCount={(updatedCount) => {
                this.setState({
                  topicExplanationCount: updatedCount,
                })
              }}
            />
          : null}

          {this.state.mode === QUESTION_STATE_MODE ? (
            <div id="categoryTab" style={{marginTop:"5rem"}}>
              <DialogContainer
                id="add-category-dialog"
                visible={this.state.visible}
                onHide={this.hide}
                actions={actions}
               title={this.state.addMode ? "New Category" : "Update Category"}
                width="500px"
                modal
              >
              {/* <p style={{fontSize:"medium"}}><b><label for="catId">New Category</label></b></p> */}
                <TextField
                  id="catId"
                  name="catagory_name"
                  label='Category Name'
                  value={this.state.temp_category.category_name || ''}
                  onChange={this.changeCategoryName}
                  fullWidth
                  // style={categoryStyles.dialogText}
                  onKeyPress={this.isEnterPressed.bind(this)}              
                />
                
                <TextField
                  id="catIdlabel"
                  name="catagory_label"
                  label='Category Label'
                  value={this.state.temp_category.category_label || ''}
                  onChange={this.changeCategoryLabel}
                  fullWidth
                  // style={categoryStyles.dialogText}
                  onKeyPress={this.isEnterPressed.bind(this)}              
                />
              </DialogContainer>
              <table style={styles.catTable} className="subjectTableClass">
                <thead style={styles.thead} >
                  <tr>
                    <th>ID</th>
                    <th style={{textAlign:'left',paddingLeft:'25px'}}>Category</th>
                    <th>Label<Button className='nocqcStyle' icon data-tip data-for='category-label'>help</Button>
                      <ReactTooltip id='category-label' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Category Label')}</span>
                      </ReactTooltip></th>
                    {/* <th colSpan="3">Total Number Of </th> */}
                    <th>SubCategories</th>
                    <th>Questions</th>
                    <th>
                      <QBExplanationHeader name={"category"} />
                    </th>
                    <th><ColumnHeader title={"Accuracy"} tooltip={"Mean Accuracy"} /></th>
                    <th><ColumnHeader title={"Time"} tooltip={"Median Time per question in seconds"} /></th>
                    {
                      !this.appProperties.enableLTI ? 
                      <th>Actions</th> : ''
                    }
                  </tr>
                 {/*  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>SubCategories</th>
                    <th>Questions</th>
                    <th>Explanations</th>
                    <th></th>
                  </tr> */}
                </thead>

                {tbody}
              </table>
              <br/>
              <center>

                {
                  !this.appProperties.enableLTI  ? 

                    <div style={this.state.currSubject ? {display:"none"}:{width:"35%"}}className='image-resize-warning'>
                    <p><b>Note :</b> Contact Administrator to gain access to edit this page.</p>
                    </div> : " "

                }
              {
                this.appProperties.enableLTI  ? 
                <div style={{width:"35%",marginTop:"10px"}} className='image-resize-warning'>
                <p><b>Note :</b> No one can make any changes in the LTI version. Please go to the OSU core question bank to make changes</p>
                </div> : " "
              }
              </center>
            </div>
          ) : null}

          {this.state.mode === TUTORIALS_STATE_MODE ?
          <div  style={{marginTop:'5rem'}}>
            <Tutorials 
              tutorialKey={`${this.state.subject_id}_${this.state.topic_id}`}
            />
            </div>
          : null}


        </div>
      </SecureShow>
    );
  }

  //Archive Restore
  onArchiveRestoreClick = (object) => {
    let payload = {
      subject_id:object.subject_id,
      topic_id:object.topic_id,
      category_id:object.category_id
    };
    restoreQuestionBankHandler(payload);
  }
}
